

const CitiOverview = () => {
    return (
        <>

            <img class="full-width img-responsive mb-5 object-position-top" src="https://www.hbku.edu.qa/sites/default/files/citi-research-training.jpg" alt="" width="1299" height="339" />
            <div class="row mb-3">
                <div class="col-md-12">
                    <div class="me-md-2">
                        {/* <h2 class="text-hbku-primary p-b-2">Responsible Conduct of Research (RCR) Training</h2> */}
                        <p class="p-b-2">Hamad Bin Khalifa University (HBKU) is committed to fostering a university-wide culture of
                            responsible and ethical research in line with international best practices. Upholding the
                            highest standards of integrity is essential to research excellence, institutional accountability,
                            and public trust in innovation.</p>
                        <p class="p-b-2">Education and training are core components of HBKU’s research governance framework and apply to all individuals involved in research activities under the University’s auspices, including undergraduate and graduate students, postdoctoral researchers, faculty, and research staff. To support the HBKU research community, the university provides access to online courses through the Institutional Training Initiative (CITI) Program, which are the Responsible Conduct of Research (RCR) Course, the Conflict of Interest (COI) Course, and the Advanced Mentorship Training.</p>


                        <div class="btn-wrapper p-b-2 flex-wrap citi-btn-wrap">
                            <a class="more px-3 px-lg-4" href="/research/rcr" target="_blank" rel="noreferrer">Explore RCR Course Modules</a>
                            <a class="more px-3 px-lg-4" href="/research/coi" target="_blank" rel="noreferrer">Explore COI Course Modules</a>
                            <a class="more px-3 px-lg-4" href="/research/advanced-mentorship-training" target="_blank" rel="noreferrer">Explore Advanced Mentorship Training</a>
                        </div>

                    </div>
                </div>

                <div class="col-md-12 mb-4">
                    <div class="warning-wrap" style={{ backgroundColor: '#faf5e8', border: '1px solid #ffeeba', padding: '15px', borderRadius: '4px' }}>
                        <h2 class="h5 p-b-0" style={{ color: '#deb449' }}><i style={{ display: 'inline-block', transform: 'translateY(-4px)' }} ><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#deb449" class="bi bi-exclamation-triangle-fill flex-shrink-0 me-2" viewBox="0 0 16 16" role="img" aria-label="Warning:">
                            <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
                        </svg></i>PLEASE NOTE</h2>
                        <p>These CITI RCR Courses are not the same as the CITI Human Subjects training required for IRB</p>
                        <i style={{ color: '#deb449' }}>CITI HUMAN SUBJECTS TRAINING</i>

                    </div>

                </div>

            </div>



        </>


    )
}
export default CitiOverview;